// eslint-disable-next-line import/prefer-default-export
import { useQueryRef } from '@hooks/url';
import type { Ref } from 'vue';
import { unref } from 'vue';
import {type MaybeRef, useLocalStorage} from '@vueuse/core';
import { useRouter } from 'vue-router';
import type { WorkingTableFieldsEntry } from '@/entities/Entities';

export const tableFieldEntriesKey = 'table_fields_entries';

type ColumnDefinition = { key: string; visible?: boolean;};
export function useTableFields(columns: MaybeRef<ColumnDefinition[]>): Ref<Record<string, boolean>> {
  const tableFieldsEntries = useLocalStorage<Record<string, WorkingTableFieldsEntry>>(tableFieldEntriesKey, {});
  const router = useRouter();
  const tableFieldsForPage = typeof router.currentRoute.value.name === 'string'
    ? unref(tableFieldsEntries)?.[router.currentRoute.value.name]?.activeFields
    : undefined;

  const structuredFields = tableFieldsForPage ? Object.fromEntries(tableFieldsForPage?.map((col) => [col, true])) : undefined;

  return useQueryRef<Record<string, boolean>>(
    'visibleColumns',
    structuredFields ?? Object.fromEntries(unref(columns).map((col) => [col.key, col.visible ?? false])),
  );
}
